const BmiForm        = document.getElementById('bmi');
const submitBtn      = document.getElementById('submitBtn');
// grab ANY element with id="startOverBtn" (desktop + mobile)
const startOverBtns  = document.querySelectorAll('.start-over-btn');
const firstPanel     = document.querySelector('.bmi-container-inner-first-v2');
const resultPanel    = document.querySelector('.bmi-container-inner-result');
const circularProgress = document.querySelectorAll('.circular-progress');

function isMobile() {
    return window.innerWidth < 768;
}
console.log(isMobile());
if (BmiForm) {
    BmiForm.addEventListener('submit', function (event) {
        event.preventDefault();

        // hide any old result text/containers
        document.querySelectorAll('.bmi-display-result-text, .bmi-result-text-con')
            .forEach(el => el.hidden = true);

        // --- your BMI calc + animation setup ---
        const height    = parseFloat(document.getElementById('bmiheight').value);
        const weight    = parseFloat(document.getElementById('bmiweight').value);
        const ethnicity = document.getElementById('ethnicity').value;
        const bmi       = (weight / ((height/100)**2)).toFixed(1);

        const updateProgress = (endValue, isAsian) => progressBar => {
            const bmiValue = progressBar.querySelector('.bmi-display-result');
            let startValue = 0, speed = 50;
            const progress = setInterval(() => {
                startValue++;
                let color = '';
                // pick your color + unhide the matching texts
                if (isAsian ? endValue < 18.5 : endValue <= 18.5) {
                    color = '#CDF1F6'; unhide(1);
                } else if (isAsian ? endValue <= 23 : endValue <= 25) {
                    color = '#3F6D73'; unhide(2);
                } else if (isAsian ? endValue <= 27.5 : endValue <= 30) {
                    color = '#FF7269'; unhide(3);
                } else {
                    color = '#882524'; unhide(4);
                }

                function unhide(n) {
                    document.querySelector(`.bmi-display-result-text.text-${n}`)
                        .removeAttribute('hidden');
                    document.querySelector(`.bmi-result-text-${n}`)
                        .removeAttribute('hidden');
                }

                let pct = startValue * 2.5 * 3.6;
                bmiValue.textContent = startValue;
                progressBar.style.background = `conic-gradient(${color} ${pct}deg, #2B2E2E 0deg)`;

                if (startValue >= endValue) {
                    clearInterval(progress);
                    bmiValue.textContent = endValue;
                }
            }, speed);
        };

        Array.from(circularProgress)
            .forEach(updateProgress(bmi, ethnicity === '2'));

        // swap panels on mobile
        if (isMobile()) {
            console.log('mobile disply block');
            firstPanel.hidden  = true;
            resultPanel.style.setProperty('display','block');
        }

        // hide submit, show start-over(s)
        submitBtn.hidden = true;
        startOverBtns.forEach(btn => btn.hidden = false);
        console.log(startOverBtns)
    });

    // wire **all** Start Over buttons to the same reset handler
    startOverBtns.forEach(btn => btn.addEventListener('click', function () {
        BmiForm.reset();
        console.log('just ran');
        // hide all texts + containers
        document.querySelectorAll('.bmi-display-result-text, .bmi-result-text-con')
            .forEach(el => el.hidden = true);

        // reset progress visuals
        circularProgress.forEach(el => {
            el.style.background = 'conic-gradient(#2B2E2E 360deg)';
            let val = el.querySelector('.bmi-display-result');
            if (val) val.textContent = '';
        });

        // swap panels back on mobile
        if (isMobile()) {
            console.log('mobile');
            firstPanel.hidden  = false;
            resultPanel.style.setProperty('display','none');
        }

        // show submit, hide start-over(s)
        submitBtn.hidden = false;
        startOverBtns.forEach(b => b.hidden = true);
    }));
}
